module.exports = "/fonts/vendor/socicon/socicon.eot?60e5857089e98edd838074c264d6c951";